import {
  Button,
  ListContainer,
  ListContext,
  PAGE_DEFAULT,
  PAGE_SIZE_UNLIMITED,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  formatCurrency,
  formatDate,
  pn,
} from "@compass/core";
import {
  Permission,
  PermissionAction,
  StudentScholarshipListDto,
  StudentScholarshipListFilter,
} from "generated/openApi";
import { useList, useRouter } from "hooks";
import { studentScholarshipPageRoute } from "pages/students/student-scholarships/StudentScholarshipPage/StudentScholarshipPage";
import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import ApiService from "services/apiService";

export const Scholarships = (props: { initialLoad: boolean; studentId: number }) => {
  const ROOT_PERMISSION: Permission = Permission.StudentScholarship;
  const navigate = useNavigate();
  const { matchTemplatePath } = useRouter();

  const [listFilter, setListFilter] = useState<StudentScholarshipListFilter>({
    scholarshipFilter: { studentId: props.studentId },
    page: PAGE_DEFAULT,
    pageSize: PAGE_SIZE_UNLIMITED,
    sortObjects: [{ property: pn<StudentScholarshipListDto>("date"), isDesc: true }],
  });
  const [listItems, setListItems] = useState<StudentScholarshipListDto[]>([]);

  const { tableContainerRef, loadList } = useList({
    listFilter: listFilter,
    setListFilter: setListFilter,
    fetchList: (listFilter) => {
      ApiService.studentScholarships.getList(listFilter).then((response) => {
        setListItems(response);
      });
    },
  });

  useEffect(() => {
    if (props.initialLoad) {
      loadList(listFilter);
    }
  }, [props.initialLoad]);

  return (
    <>
      <ListContainer
        fullHeight
        header={
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="inherit">Scholarships</Typography>

            <Stack direction="row" alignItems="center" spacing="sm">
              {isAuthorized(ROOT_PERMISSION, PermissionAction.Create) && (
                <Button
                  variant="text"
                  onClick={() =>
                    navigate({
                      pathname: studentScholarshipPageRoute.getPath({ id: 0, crudMode: "edit", screenType: "dialog" }),
                      search: studentScholarshipPageRoute.getOptionalParams?.({
                        studentId: props.studentId,
                      }),
                    })
                  }
                  sx={{ minWidth: "auto" }}
                >
                  + New
                </Button>
              )}
            </Stack>
          </Stack>
        }
        tableContainer={
          <TableContainer ref={tableContainerRef}>
            <Table stickyHeader>
              <TableBody>
                {listItems?.map((listItem) => (
                  <TableRow
                    key={listItem.id}
                    onClick={() =>
                      navigate({
                        pathname: studentScholarshipPageRoute.getPath({
                          id: listItem.id,
                          crudMode: "view",
                          screenType: "dialog",
                        }),
                      })
                    }
                  >
                    <TableCell>{listItem.scholarshipType}</TableCell>
                    <TableCell align="right">{formatCurrency(listItem.amount)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        }
      />

      <ListContext.Provider value={{ loadList: (options) => loadList(listFilter, { resetPage: options?.resetPage }) }}>
        {matchTemplatePath(studentScholarshipPageRoute.templatePath) && <Outlet />}
      </ListContext.Provider>
    </>
  );
};
